import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "full"]

  toggle() {
    this.previewTarget.classList.toggle("hidden")
    this.fullTarget.classList.toggle("hidden")
  }
}
